/*
 * @Author: Hong.Zhang
 * @Date: 2021-11-02 17:45:01
 * @Description:  
 */
export const Colors = {
  primary: '#5858FF',
  primarLight: '#F6F6FF',
  black: '#212121',
  grantie: '#666666',
  stone: '#999999',
  fog: '#BDBDBD', // usually used to display disbaled state
  grey: '#EEEEEE',
  ice: '#F9F9F9',
  white: '#FFFFFF',
  transparent: 'transparent',
  green: '#108043',
  lightGreen: '#EEFFEA',
  blue: '#1E90FF',
  lightBlue: '#E4F2FF',
  red: '#F52209',
  lightRed: '#FEE4E1',
  yellow: '#CF8909',
  lightYellow: '#FFF9ED',
  mask: '#0000007f',
}